import React, { ReactNode, useState } from 'react';
import { ImageDataType, NewMealXlsContext } from './context';
import { BaseAddonCategoryType, BrandOption, CreateMealXlsType, MealType } from 'utils/types';
const NewMealXlsProvider = ({ children }: { children: ReactNode }) => {
  const [meals, setMeals] = useState([] as any);
  const [mappedMeals, setMappedMeals] = useState([] as Partial<CreateMealXlsType[]>);
  const [selectedBrand, setSelectedBrand] = useState<BrandOption | undefined>();
  const [reviewedMeals, setReviewedMeals] = useState<string[]>([]);
  const [imageFiles, setImageFiles] = useState<Array<File>>([]);
  const [xlsFile, setXlsFile] = useState<File | null>(null);
  const [imageData, setImageData] = useState<ImageDataType[]>([]);
  const [baseMeals, setBaseMeals] = useState<MealType[]>([]);
  const [baseAddonCategories, setBaseAddonCategories] = useState<BaseAddonCategoryType[]>([]);

  return (
    <NewMealXlsContext.Provider
      value={{
        xlsFile,
        setXlsFile,
        imageFiles,
        setImageFiles,
        imageData,
        setImageData,
        meals,
        setMeals,
        mappedMeals,
        setMappedMeals,
        selectedBrand,
        setSelectedBrand,
        reviewedMeals,
        setReviewedMeals,
        baseAddonCategories,
        setBaseAddonCategories,
        baseMeals,
        setBaseMeals
      }}>
      {children}
    </NewMealXlsContext.Provider>
  );
};

export default NewMealXlsProvider;
